export const LOGO =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_learn-german-55/artifacts/rx2c0kof_JA%21%20Consulting%20%26%20Support-01.webp";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1647776112336-72f4c30fafc1",
  consulting: "https://images.pexels.com/photos/36765732/pexels-photo-36765732.jpeg",
  events: "https://images.pexels.com/photos/34321369/pexels-photo-34321369.jpeg",
  equipment: "https://static.prod-images.emergentagent.com/jobs/0ccf1178-5ac2-4156-bf78-084e653373d6/images/b57f694757e33a8d9c471adf94598e874aadf08019c8dea0407e18e71a0858ed.jpeg",
  cocktail: "https://images.unsplash.com/photo-1779591212051-55edcdd3e15b",
  team: "https://images.unsplash.com/photo-1758526348403-b729c700d675",
  training: "https://images.unsplash.com/photo-1647404249310-fc06bd0c11f2",
  cocktailkurs: "https://images.unsplash.com/photo-1509669803555-fd5edd8d5a41",
};

export const NAV_KEYS = [
  { key: "leistungen", href: "#leistungen" },
  { key: "equipment", href: "#equipment" },
  { key: "about", href: "#ueber-uns" },
  { key: "kontakt", href: "#kontakt" },
];
